/* Grind Unlock Banner - Cart Drawer (Horizon) */
(function () {
  if (window.__grindUnlockInit) return;
  window.__grindUnlockInit = true;

  var BOX_HANDLES = ['the-grind-funnel', 'the-spread'];
  var BANNER_ID = 'grind-unlock-banner';
  var STYLE_ID = 'grind-unlock-banner-styles';

  function injectStyles() {
    if (document.getElementById(STYLE_ID)) return;
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = [
      '#grind-unlock-banner{display:flex;align-items:center;gap:12px;margin:8px 16px 16px 16px;padding:12px 14px;border-radius:10px;background:linear-gradient(135deg,#1f3d27 0%,#2f5a3a 100%);color:#fff;box-shadow:0 1px 3px rgba(0,0,0,.12);font-family:inherit;}',
      '#grind-unlock-banner .gub-icon{flex:0 0 28px;width:28px;height:28px;border-radius:50%;background:#fff;color:#1f3d27;display:flex;align-items:center;justify-content:center;}',
      '#grind-unlock-banner .gub-text{display:flex;flex-direction:column;line-height:1.25;}',
      '#grind-unlock-banner .gub-title{font-weight:700;font-size:14px;letter-spacing:.01em;}',
      '#grind-unlock-banner .gub-sub{font-size:12px;opacity:.88;margin-top:2px;}',
      '@media (max-width:480px){#grind-unlock-banner{margin:6px 12px 12px 12px;padding:10px 12px;}#grind-unlock-banner .gub-title{font-size:13px;}#grind-unlock-banner .gub-sub{font-size:11px;}}'
    ].join('');
    document.head.appendChild(style);
  }

  function hasGrind(cart) {
    if (!cart || !cart.items) return false;
    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i];
      if (BOX_HANDLES.indexOf(it.handle) !== -1 && it.selling_plan_allocation) return true;
    }
    return false;
  }

  function findTarget() {
    var drawer = document.querySelector('cart-drawer-component');
    if (drawer) {
      return drawer.querySelector('[ref="body"]') ||
             drawer.querySelector('.cart-drawer__body') ||
             drawer.querySelector('.cart-drawer__content') ||
             drawer.querySelector('dialog') ||
             drawer;
    }
    return document.querySelector('.main-cart, #main-cart');
  }

  function render(container) {
    if (document.getElementById(BANNER_ID)) return;
    var b = document.createElement('div');
    b.id = BANNER_ID;
    b.setAttribute('role', 'status');
    b.setAttribute('aria-live', 'polite');
    b.innerHTML = [
      '<span class="gub-icon" aria-hidden="true">',
      '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">',
      '<path d="M3 8.5l3 3 7-7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>',
      '</svg>',
      '</span>',
      '<span class="gub-text">',
      '<span class="gub-title">You&rsquo;ve unlocked a FREE bacon pack</span>',
      '<span class="gub-sub">Ships with your first Grind box</span>',
      '</span>'
    ].join('');
    if (container.firstChild) container.insertBefore(b, container.firstChild);
    else container.appendChild(b);
  }

  function remove() {
    var b = document.getElementById(BANNER_ID);
    if (b && b.parentNode) b.parentNode.removeChild(b);
  }

  function sync() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (hasGrind(cart)) {
          var t = findTarget();
          if (t) { injectStyles(); render(t); }
        } else { remove(); }
      })
      .catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }
  document.addEventListener('cart:update', sync);
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('[data-drawer-action="open"], .cart-icon, cart-icon, [aria-controls="cart-drawer"]')) {
      setTimeout(sync, 80);
    }
  }, true);
})();
